export default "__VITE_ASSET__Dl0uR16f__"